module.exports = __webpack_public_path__ + "img/2.99b64337.jpg";